import '@tamagui/core/reset.css'

import { Button, H3, H4, ListItem, Spinner, Text, XStack, YStack } from 'tamagui'
import { useLocation, useNavigate } from 'react-router-dom'
import { getOrganizationSuppliers, SupplierData } from '../remote/suppliers'
import { useEffect, useState } from 'react'
import { Building, Building2, ChevronRight, ChevronRightCircle, Origami, Pencil, Plus } from '@tamagui/lucide-icons'

export class ManageSuppliersProps {
	org: string;

	constructor(org: string) {
		this.org = org;
	}
}

export const ManageSuppliers = (props: ManageSuppliersProps) => {
	const navigate = useNavigate()

	const [orgSuppliers, setOrgSuppliers] = useState<SupplierData[] | null>(null);
	const [isLoaded, setIsLoaded] = useState(false)
	useEffect(() => {
		getOrganizationSuppliers(props.org, (data, resp) => {
			if (data) {
				setOrgSuppliers(data);
				setIsLoaded(true);
			} else {
				setOrgSuppliers(null);
				setIsLoaded(false);
			}
		});
	}, [setOrgSuppliers, setIsLoaded]);

	return (
	  <>
			<XStack>
				<H4>Suppliers</H4>
				<Button onPress={() => navigate(`/manage/org/${props.org}/suppliers/add`)} iconAfter={Plus} marginLeft='auto' alignSelf='center'>Add an existing supplier</Button>
				<Button onPress={() => navigate(`/manage/org/${props.org}/suppliers/create`)} iconAfter={Plus} marginLeft='$4' alignSelf='center'>Create a new supplier</Button>
			</XStack>
		  {
			isLoaded && orgSuppliers
			? <>
				{orgSuppliers && orgSuppliers.length > 0 ? orgSuppliers.map((supplier: SupplierData) => {
					return (
						<ListItem onPress={() => navigate(`/manage/supplier/${supplier.id}`)} icon={Origami} title={supplier.name} iconAfter={ChevronRight} hoverTheme pressTheme>
						</ListItem>
					)
				}) : <Text>This organization has no suppliers!</Text>}
			</>
			: <>
				<Spinner></Spinner>
			</>
		  }
	  </>
	)
}
